/** Idb */
export const CLIENTS_SUPPORT_DB_NAME: string = 'multipassBackOfficeDB';
export const CLIENTS_SUPPORT_TABLE_NAME: string = 'clients';
export const CLIENTS_SUPPORT_DB_VERSION: number = 1;
